import React, { useRef, useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {Helmet} from "react-helmet";
import { base_url_url } from "../../igtComponant/Links";
import { careerItem } from './data';
import './style.css';
import {Link} from 'react-router-dom';

const Career = () => {
  return (<>
    <Helmet>
        <title>Career | IGTechso </title>
        <link rel="canonical" href={`${process.env.PUBLIC_URL}/blog`}></link>
        <meta name="description" content="IGT" />
        <meta name="keywords" content="IGT" />
        <meta name="author" content="IGT" />
    </Helmet>
    <section className="services-header" id="career">
        <div className="bg">
            <img src={`${base_url_url}service-bottom-left.png`} alt="Background Layer" title="Background Layer" width="auto" height="auto" className="bottom-left" />
            <img src={`${base_url_url}service-top-right.png`} alt="Background Layer" title="Background Layer" width="auto" height="auto"className="top-right"/>
        </div>
        <div className="container">
            <div className="row careerPage">
                <div className='col-sm-6'><img src="https://www.infowindtech.com/wp-content/uploads/2022/02/about-us-vector.png" alt="career" width="auto" height="auto" /></div>
                <div className='col-sm-6'>
                    <div className="content-section">
                        <h2>Why join us</h2>
                        <p>IGTechso Pvt. Ltd. believes in individual growth as a team only stays positive when correct opportunities with proper support is provided.IT industry keeps upgrading itself on a daily basis & so should people working in the same industry.Professionalism & Empathy is what we offer our people & are very happy with the returns we have received from them in the past & present.Join us & see for yourself, how focus on something gets us reasons & solution to be reach our ultimate goal.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row">
                <div className="content-section careerLoop">
                   {
                     careerItem.map((item)=> 
                        <div className='itemCareer' key={item.id}>
                            <h3><i className={'fa '+item.icon}></i> {item.title}</h3>
                            <p><span>Experience:</span>- {item.experience}</p>
                            <p><span>Location:</span>- {item.location}</p>
                            <div className="btnSection">
                                <Link className="btn-1" to={`/career/${item.id}`} ><span></span><span></span><span></span>Read Details & Apply</Link>
                            </div>
                        </div>)  
                   }
                </div> 
            </div>
        </div>        
    </section>
    </>
  )
}

export default Career;


